import React from 'react';
import { Link } from 'react-router-dom';
import { useLiveStream } from '../contexts/LiveStreamContext';
import './LiveStreamBanner.css';

const LiveStreamBanner: React.FC = () => {
  const { liveStream } = useLiveStream();

  if (!liveStream) {
    return null;
  }

  return (
    <Link to="/sermons" className="live-stream-banner">
      <span className="live-stream-banner-dot" aria-hidden="true"></span>
      <span className="live-stream-banner-text">
        <strong>LIVE NOW</strong>
        <span className="live-stream-banner-title">{liveStream.title}</span>
      </span>
      <span className="live-stream-banner-cta">Watch Live</span>
    </Link>
  );
};

export default LiveStreamBanner;
